// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input::-webkit-calendar-picker-indicator{opacity:100;margin-bottom:6px}\n", ""]);
// Exports
module.exports = exports;
